import React from 'react';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import dayjs from 'dayjs';

export function DateCell({ date }: { date: string | Date | undefined }): React.JSX.Element {
  return (
    <Stack>
      <Typography sx={{ textWrap: 'nowrap' }} variant="body2">
        {dayjs(date).format('MMM D, YYYY h:mm A')}
      </Typography>
      <Typography sx={{ textWrap: 'nowrap' }} variant="caption" color="textSecondary">
        {dayjs(date).fromNow()}
      </Typography>
    </Stack>
  );
}
